module.exports = __webpack_public_path__ + "static/media/filters.7fc61f9d.svg";